/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 2.4c-5.408 0-9.6 3.961-9.6 9.312 0 2.799 1.147 5.217 3.015 6.888.157.14.251.337.258.547l.052 1.708c.017.544.58.899 1.078.679l1.905-.841a.766.766 0 0 1 .513-.038c.876.24 1.808.37 2.779.37 5.408 0 9.6-3.962 9.6-9.313 0-5.35-4.192-9.312-9.6-9.312Z",
  fill: "url(#jp9vsek__a)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m6.235 14.435 2.82-4.474a1.44 1.44 0 0 1 2.082-.384l2.243 1.682a.576.576 0 0 0 .694-.002l3.03-2.299c.404-.306.931.177.66.607l-2.82 4.474a1.44 1.44 0 0 1-2.081.384l-2.243-1.682a.576.576 0 0 0-.694.002l-3.03 2.299c-.404.306-.931-.177-.66-.607Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "jp9vsek__a",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(6.096 21.497) scale(20.9203)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#09F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.61,
  stopColor: "#A033FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.935,
  stopColor: "#FF5280"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF7061"
})))), "0 0 24 24", "ColoredMessenger");